import BaseService from './BaseService';
import axiosInstance from './axios';
import * as apiroutes from '../apiRoutes';

class CompanyService extends BaseService {
    constructor() {
        super(apiroutes.companyRegistration);
    }
    async create(data) {
        //return await super.create(data);
        return await super.customCall('POST', "", data, null, 'multipart');

    }
    async createByAdmin(data) {
        //return await super.create(data);
        return await super.customCall('POST', `/admin-invite`, data, null, 'json');

    }
    async compliteUserRegistration(data, id) {

        //return await super.create(data);
        return await super.customCall('POST', `/complete-registration/${id}`, data, null, 'json');

    }
    async update(id, data) {
        // If data is FormData (contains file), use multipart (same as CategoryService)
        const contentType = data instanceof FormData ? 'multipart' : 'json';
        return await super.customCall('PATCH', `/${id}`, data, null, contentType);
    }

    async updateLoyaltyProgram(id, loyaltyEnabled) {
        const url = `${apiroutes.companyRegistration}/${id}`;
        const response = await axiosInstance.patch(url, { loyaltyEnabled });
        return response.data;
    }

    async delete(id) {
        return await super.delete(id)
    }

    async get(params = {}) {
        return await super.getAll(params)
    }
    async getAll(params = {}) {
        return await super.customCall("GET", '', null, params, null)
    }
    async getFromPost(params = {}) {
        return await super.getByPost(params)
    }

    async getById(id) {
        return await super.getById(id)
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters)
    }
}

const CompanyServices = new CompanyService();
export default CompanyServices;